/* ============================================================================
   Theme-Pfad: assets/lw-cart-page.js
   V6 "Cool Apple Day-One" · LW24 Cart-Page Mutations + Re-Render
   ----------------------------------------------------------------------------
   Bindet die Quantity-Stepper und Remove-Buttons an die Shopify Cart-API.
   Re-rendert die Section nach jeder Änderung über die Section-Rendering-API.
   Feuert "cart:updated" damit der Header-Counter + Drawer mitkommen.
   ============================================================================ */

(function () {
  if (window.__lwCartPageInit) return;
  window.__lwCartPageInit = true;

  /* ⚠️⚠️ DER SCHLUESSEL AUS templates/cart.json IST NICHT DIE SECTION-ID.
     Bei einer JSON-Vorlage heisst die id `template--<theme_id>__<schluessel>`,
     und genau die will die Section-Rendering-API im `sections`-Feld sehen;
     der Knoten drumherum heisst entsprechend
     `#shopify-section-template--<theme_id>__<schluessel>`.

     Hier standen bis zum 07.09.2026 die blossen Namen, erst "main" und
     "summary", dann "main-cart-items" und "main-cart-footer". Beide Male
     ging es lautlos schief: `data.sections['main-cart-items']` blieb
     undefined, `#shopify-section-main-cart-items` gab es nicht, und
     replaceSectionHTML stieg bei `if (!html) return;` sofort wieder aus.
     Nach jedem Klick auf + oder - blieb die Seite stehen.

     ⚠️ SO MACHT ES DAWN, UND DESHALB MACHEN WIR ES AUCH SO: die Section
     gibt ihre eigene id in ein data-Attribut aus, das Skript liest sie von
     dort und schickt sie. assets/cart.js:126 tut genau das
     (`document.getElementById('main-cart-items').dataset.id`), und Zeile
     185 liest die Antwort unter demselben Schluessel wieder aus. Wer den
     Schluessel in templates/cart.json umbenennt, muss hier NICHTS
     nachziehen - nur die Ableitung des Fusses unten stimmt dann nicht mehr.

     ⚠️ DIE BEIDEN KONSTANTEN SIND TROTZDEM KEIN TOTER CODE, UND ZWAR AUS
     ZWEI GRUENDEN. Erstens sind sie der Rueckfall, falls das
     data-Attribut fehlt (Section nicht gerendert, Markup umgebaut).
     Zweitens - und das ist der wichtigere - will die ANDERE API, das
     blosse `?section_id=` weiter unten, genau diesen blossen Namen sehen
     und nicht die volle id. Der Unterschied steht bei ladeSection(). */
  const SECTION_MAIN = 'main-cart-items';
  const SECTION_FOOT = 'main-cart-footer';

  /* Die echten Section-ids, aus dem Markup gelesen. Der Fuss rendert bei
     leerem Warenkorb nichts (unless hide_section), sein data-Attribut kann
     also fehlen: dann wird die id aus der des Kopfes abgeleitet, denn beide
     tragen dasselbe `template--<theme_id>__`-Praefix. */
  function sectionIds() {
    const kopf = document.querySelector('[data-cart-main]');
    const idKopf = kopf && kopf.getAttribute('data-section-id');
    if (!idKopf) return { main: SECTION_MAIN, foot: SECTION_FOOT };
    const fuss = document.querySelector('[data-cart-foot]');
    const idFuss = (fuss && fuss.getAttribute('data-section-id'))
      || idKopf.replace(/main-cart-items$/, 'main-cart-footer');
    return { main: idKopf, foot: idFuss };
  }

  // ---------- Helpers ----------
  function debounce(fn, ms) {
    let t;
    return function () {
      clearTimeout(t);
      const args = arguments, ctx = this;
      t = setTimeout(() => fn.apply(ctx, args), ms);
    };
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function updateLine(line, qty, ids) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      /* ⚠️ sections_url IST PFLICHT, SONST RENDERT SHOPIFY GEGEN "/".
         Ohne den Parameter loest die Section-Rendering-API die Namen gegen
         die Vorgabe-URL auf, nicht gegen /cart. Beide Sections sind aber
         ueber "enabled_on: templates: [cart]" auf die Warenkorbseite
         beschraenkt: auf der Startseite gerendert kommt nichts Brauchbares
         zurueck. Jede andere Stelle im Theme, die Sections ueber die
         Cart-API nachlaedt, setzt ihn (assets/cart.js, product-form.js,
         quick-add-bulk.js, quick-order-list.js). */
      body: JSON.stringify({
        id: line, quantity: qty,
        sections: [ids.main, ids.foot],
        sections_url: window.location.pathname
      })
    });
    return res.json();
  }

  /* ⚠️ WAS DAS ERSETZEN SONST MITNIMMT.
     Solange die Section gar nicht ersetzt wurde (der Fehler mit den
     Section-Schluesseln, siehe oben), sind die beiden folgenden Dinge nie
     aufgefallen. Seit es funktioniert, fallen sie sofort auf:

     1. DIE BESTELLNOTIZ. Das <textarea> wird aus {{ cart.note }} neu
        gerendert, und dort steht der Text erst NACH dem Absenden des
        Formulars. Wer die Notiz tippt und danach auf + drueckt, verliert
        sie kommentarlos. Sie wird deshalb samt dem Aufklapp-Zustand
        gesichert und danach zurueckgeschrieben.
     2. DER TASTATURFOKUS. Der geklickte Knopf wird mitsamt der Section
        ersetzt, der fokussierte Knoten ist danach nicht mehr im Dokument
        und der Fokus faellt auf den <body>. Wer die Menge mit der Tastatur
        von 1 auf 3 stellt, muss sich zweimal neu dorthin tabben.
        Gemerkt wird, WELCHE Zeile und WELCHE Rolle den Fokus hatte, nicht
        der Knoten selbst: den gibt es danach nicht mehr. */
  function merkeZustand(wrapper) {
    const z = { notiz: null, notizOffen: false, fokus: null };
    const ta = wrapper.querySelector('[name="note"]');
    if (ta) {
      z.notiz = ta.value;
      const details = ta.closest('details');
      z.notizOffen = !!(details && details.open);
    }
    const a = document.activeElement;
    if (a && wrapper.contains(a)) {
      /* ⚠️ DAS NOTIZFELD BRAUCHT EINEN EIGENEN ZWEIG, UND ZWAR WEGEN DES
         ZWEITEN DURCHLAUFS. Der Fokus wurde bisher nur ueber data-line-key
         gemerkt, und das Textfeld traegt keins: die Wiederherstellung stieg
         darum unten sofort aus. Beim eigenen Klick faellt das kaum auf, weil
         die Notiz da noch niemand offen hat. Getroffen hat es den Fall
         danach: der Counter-Sync des Schubfachs haengt sich an dasselbe
         fetch und feuert 350 ms spaeter ein zweites cart:updated, die Seite
         laedt also ein zweites Mal nach. Wer in der Sekunde die Notiz
         aufklappt und lostippt, verliert den Cursor mitten im Satz - der
         Text bleibt stehen, die Schreibmarke springt weg.
         Gemerkt wird deshalb auch die Auswahl, sonst landet der Cursor am
         Anfang statt dort, wo er war. */
      const ta2 = wrapper.querySelector('[name="note"]');
      if (ta2 && a === ta2) {
        z.fokus = { notiz: true, von: ta2.selectionStart, bis: ta2.selectionEnd };
      } else {
        z.fokus = {
          zeile: a.getAttribute('data-line-key'),
          schritt: a.getAttribute('data-cart-qty-step'),
          entfernen: a.hasAttribute('data-cart-remove'),
          eingabe: a.hasAttribute('data-cart-qty-input')
        };
      }
    }
    return z;
  }

  function stelleWiederHer(wrapper, z) {
    if (z.notiz !== null) {
      const ta = wrapper.querySelector('[name="note"]');
      if (ta) {
        ta.value = z.notiz;
        const details = ta.closest('details');
        if (details && z.notizOffen) details.open = true;
      }
    }
    if (!z.fokus) return;
    if (z.fokus.notiz) {
      const ta3 = wrapper.querySelector('[name="note"]');
      if (ta3) {
        ta3.focus();
        /* setSelectionRange wirft bei einem Feld, das den Typ nicht
           unterstuetzt; ein textarea tut es, aber der Aufruf kostet nichts
           im try. */
        try { ta3.setSelectionRange(z.fokus.von, z.fokus.bis); } catch (err) {}
      }
      return;
    }
    if (!z.fokus.zeile) return;
    const inZeile = '[data-line-key="' + (window.CSS && CSS.escape ? CSS.escape(z.fokus.zeile) : z.fokus.zeile) + '"]';
    let ziel = null;
    if (z.fokus.entfernen) ziel = wrapper.querySelector('[data-cart-remove]' + inZeile);
    else if (z.fokus.eingabe) ziel = wrapper.querySelector('[data-cart-qty-input]' + inZeile);
    else if (z.fokus.schritt) ziel = wrapper.querySelector('[data-cart-qty-step="' + z.fokus.schritt + '"]' + inZeile);
    if (ziel) ziel.focus();
  }

  /* ⚠️ HIER GILT DER BLOSSE NAME, IM POST OBEN DIE VOLLE ID. Das ist kein
     Versehen, sondern der Unterschied zwischen zwei APIs, und Dawn macht es
     genauso: `?section_id=` bekommt in assets/cart.js:109 den blossen
     Schluessel `main-cart-items`, waehrend das `sections`-Feld von
     /cart/change.js in Zeile 126/156 die volle `template--<theme_id>__`-id
     bekommt. Wer hier die volle id einsetzt, weil sie oben richtig ist, holt
     sich eine leere Antwort - lautlos, weil `res.ok` dann trotzdem stimmen
     kann. Deshalb erst der Name, und nur wenn der Server nein sagt, die id.

     Der zweite Parameter ist immer die volle id: das ist der KNOTEN im
     Dokument, nicht der Schluessel der API. */
  async function ladeSection(name, domId) {
    let res = await fetch(window.location.pathname + '?section_id=' + encodeURIComponent(name));
    if (!res.ok && domId !== name) {
      res = await fetch(window.location.pathname + '?section_id=' + encodeURIComponent(domId));
    }
    if (res.ok) replaceSectionHTML(domId, await res.text());
  }

  function replaceSectionHTML(sectionId, html) {
    if (!html) return;
    /* getElementById statt querySelector, an BEIDEN Stellen: die id wird
       hier zur Laufzeit zusammengesetzt und enthaelt bei einer
       JSON-Vorlage `template--<theme_id>__`. Als Selektor waere das zwar
       gueltig (ein CSS-Bezeichner darf Bindestriche und Unterstriche in
       der Mitte tragen), aber jede kuenftige Section-id muesste man erst
       auf Sonderzeichen pruefen. getElementById nimmt den Namen
       woertlich und stellt die Frage gar nicht. */
    const wrapper = document.getElementById('shopify-section-' + sectionId);
    if (!wrapper) return;
    const zustand = merkeZustand(wrapper);
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const fresh = doc.getElementById('shopify-section-' + sectionId);
    if (fresh) wrapper.innerHTML = fresh.innerHTML;
    else wrapper.innerHTML = html;
    stelleWiederHer(wrapper, zustand);
  }

  /* ⚠️ DER RIEGEL GEGEN DIE EIGENE SCHLEIFE GRIFF NIE.
     Der Lauscher weiter unten steigt bei detail.__fromCartPage aus, gesetzt
     hat das Merkmal aber niemand: hier ging das rohe cart-Objekt raus. Der
     eigene Lauscher hat also auf das eigene Ereignis reagiert und beide
     Sections ein zweites Mal geholt. Dazu feuert der Counter-Sync des
     Schubfachs dasselbe Ereignis, macht drei Rendervorgaenge je Klick, und
     die spaeteste Antwort gewinnt - auch wenn sie den aelteren Stand
     traegt. */
  function dispatchCartUpdated(cart) {
    const detail = Object.assign({}, cart, { __fromCartPage: true });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
  }

  function showSpinner(target, on) {
    if (!target) return;
    target.classList.toggle('is-loading', !!on);
    target.style.pointerEvents = on ? 'none' : '';
    target.style.opacity = on ? '0.5' : '';
  }

  // ---------- Handlers ----------
  async function handleStep(btn) {
    const item = btn.closest('[data-cart-line-item]');
    if (!item) return;
    const lineKey = btn.getAttribute('data-line-key');
    const step = parseInt(btn.getAttribute('data-cart-qty-step'), 10);
    const input = item.querySelector('[data-cart-qty-input]');
    if (!input) return;
    const current = parseInt(input.value, 10) || 0;
    const next = Math.max(0, current + step);
    await applyQuantity(item, lineKey, next);
  }

  async function handleRemove(btn) {
    const item = btn.closest('[data-cart-line-item]');
    if (!item) return;
    const lineKey = btn.getAttribute('data-line-key');
    await applyQuantity(item, lineKey, 0);
  }

  async function handleInputChange(input) {
    const item = input.closest('[data-cart-line-item]');
    if (!item) return;
    const lineKey = input.getAttribute('data-line-key');
    const next = Math.max(0, parseInt(input.value, 10) || 0);
    await applyQuantity(item, lineKey, next);
  }

  async function applyQuantity(item, lineKey, qty) {
    showSpinner(item, true);
    const ids = sectionIds();
    try {
      const data = await updateLine(lineKey, qty, ids);
      if (data && data.sections) {
        /* Erst unter der echten id nachsehen, dann unter dem blossen
           Namen: der Rueckfall kostet nichts und faengt es ab, falls
           Shopify die Antwort einmal anders schluesselt. */
        replaceSectionHTML(ids.main, data.sections[ids.main] || data.sections[SECTION_MAIN]);
        replaceSectionHTML(ids.foot, data.sections[ids.foot] || data.sections[SECTION_FOOT]);
      }
      const cart = await fetchCart();
      dispatchCartUpdated(cart);
    } catch (err) {
      console.error('[lw-cart-page] update failed', err);
    } finally {
      /* ⚠️ DAS ZURUECKSETZEN STAND NUR IM catch-ZWEIG. Im Erfolgsfall
         sollte es dadurch geschehen, dass die Section ersetzt wird und die
         Zeile mit ihrem inline-Stil verschwindet. Solange das Ersetzen
         nicht funktionierte (siehe Kommentar an SECTION_MAIN), blieb die
         Zeile fuer immer auf opacity .5 und pointer-events: none stehen -
         ein Klick auf + hat den Warenkorb also sichtbar eingefroren.
         Jetzt laeuft es in beiden Faellen. Auf einem Knoten, der schon
         ersetzt wurde, tut es nichts, das ist unschaedlich. */
      showSpinner(item, false);
    }
  }

  const debouncedInput = debounce(handleInputChange, 400);

  // ---------- Delegation ----------
  document.addEventListener('click', function (e) {
    const stepBtn = e.target.closest('[data-cart-qty-step]');
    if (stepBtn) { e.preventDefault(); handleStep(stepBtn); return; }
    const rmBtn = e.target.closest('[data-cart-remove]');
    if (rmBtn) { e.preventDefault(); handleRemove(rmBtn); return; }
  });

  document.addEventListener('change', function (e) {
    const input = e.target.closest('[data-cart-qty-input]');
    if (input) debouncedInput(input);
  });

  // Note: textarea[name="note"] wird beim Submit mitgesendet — kein Extra-JS nötig.

  // ---------- Listener für externe Updates (Quick-Add, Drawer) ----------
  /* ⚠️ DER RIEGEL FAENGT NUR DAS EIGENE EREIGNIS, NICHT DEN NACHZUEGLER, UND
     DAS IST BEWUSST SO GELASSEN (07.09.2026). Der Counter-Sync des Schubfachs
     haengt sich an jedes fetch auf eine Warenkorb-URL und feuert 350 ms nach
     der Antwort ein zweites cart:updated - ohne __fromCartPage, also laeuft
     dieser Lauscher noch einmal und laedt beide Sections erneut.

     Das kostet zwei ueberfluessige Abrufe je Klick. Unterdruecken liesse es
     sich mit einem Zeitfenster nach der eigenen Mutation, aber dann faellt
     auch eine ECHTE Aenderung von woanders in dieses Fenster - etwa aus dem
     Schubfach, das auf derselben Seite offen sein kann. Ein zu viel
     gerenderter Abschnitt ist harmloser als ein verschluckter.

     Der Schaden, den der Nachzuegler wirklich angerichtet hat, war der
     Cursor in der Bestellnotiz, und den faengt merkeZustand() jetzt ab. */
  document.addEventListener('cart:updated', async function (e) {
    // Re-render only if not triggered by us (avoid loop)
    if (e.detail && e.detail.__fromCartPage) return;
    if (!document.body.classList.contains('template-cart')) return;
    try {
      const ids = sectionIds();
      await ladeSection(SECTION_MAIN, ids.main);
      await ladeSection(SECTION_FOOT, ids.foot);
    } catch (err) { /* stumm: ein fehlgeschlagenes Nachladen darf die
                       Seite nicht anhalten, der Warenkorb selbst stimmt */ }
  });
})();